import { Action, ActionReducer } from '@ngrx/store';

export function concatReducers<V>(
  ...reducers: Array<ActionReducer<V>>
): ActionReducer<V, Action> {
  const func = (state: V, action: Action) => {
    const reduced = reducers.reduce(
      (accumulatedState, reducer) => reducer(accumulatedState, action),
      state
    );
    return reduced;
  };
  return func as ActionReducer<V, Action>;
}
